import {
    OpenAIIcon,
    StabilityAIIcon,
    UnsplashIcon,
    PexelsIcon,
    PixabayIcon,
    GoogleIcon,
    BingIcon,
    IdeogramIcon,
    FluxIcon,
    GrokIcon,
    GeminiIcon,
} from "@Icons/index";
import _find from "lodash/find";
import _filter from "lodash/filter";
import _groupBy from "lodash/groupBy";
import _map from "lodash/map";

export const models = [
    // openai
    {
        id: "gpt_image_1_medium",
        name: "GPT Image 1 Medium",
        provider: "dall_e",
        group: "dall_e",
        icon: OpenAIIcon,
        price: 0.063,
        is_ai: true,
        description: "Modèle avancé pour des images précises, riches en détails et fidèles aux prompts.",
    },

    {
        id: "gpt_image_1_high",
        name: "GPT Image 1 High",
        provider: "dall_e",
        group: "dall_e",
        icon: OpenAIIcon,
        price: 0.25,
        is_ai: true,
        description: "Modèle avancé pour des images précises, riches en détails et fidèles aux prompts.",
    },

    // stable diffusion
    {
        id: "stable_diffusion_core",
        name: "Stable Image Core",
        provider: "stable_diffusion",
        group: "stable_diffusion",
        icon: StabilityAIIcon,
        price: 0.03,
        is_ai: true,
        description: "Bon rendu global avec une exécution efficace et fluide.",
    },
    {
        id: "stable_diffusion_sd3_5_medium",
        name: "Stable Diffusion 3.5 Medium",
        provider: "stable_diffusion",
        group: "stable_diffusion",
        icon: StabilityAIIcon,
        price: 0.035,
        is_ai: true,
        description: "Idéal pour générer des images équilibrées avec un style moderne.",
    },
    {
        id: "stable_diffusion_sd3_5_large",
        name: "Stable Diffusion 3.5 Large",
        provider: "stable_diffusion",
        group: "stable_diffusion",
        icon: StabilityAIIcon,
        price: 0.065,
        is_ai: true,
        description: "Rendu de grande qualité, parfait pour des scènes riches et complexes.",
    },
    {
        id: "stable_diffusion_sd3_5_large_turbo",
        name: "Stable Diffusion 3.5 Large Turbo",
        provider: "stable_diffusion",
        group: "stable_diffusion",
        icon: StabilityAIIcon,
        price: 0.04,
        is_ai: true,
        description: "Très rapide tout en maintenant un haut niveau de détail visuel.",
    },
    {
        id: "stable_diffusion_ultra",
        name: "Stable Image Ultra",
        provider: "stable_diffusion",
        group: "stable_diffusion",
        icon: StabilityAIIcon,
        price: 0.08,
        is_ai: true,
        description: "Spécialisé dans les visuels haut de gamme avec un niveau de réalisme élevé.",
    },

    // ideogram
    {
        id: "ideogram_v_3",
        name: "Ideogram 3.0",
        provider: "ideogram",
        group: "ideogram",
        icon: IdeogramIcon,
        price: 0.06,
        is_ai: true,
        description: "Bon rendu typographique et génération d’images stylisées originales.",
    },
    {
        id: "ideogram_v_3_turbo",
        name: "Ideogram 3.0 Turbo",
        provider: "ideogram",
        group: "ideogram",
        icon: IdeogramIcon,
        price: 0.02,
        is_ai: true,
        description: "Rapide et efficace pour créer des compositions visuelles attrayantes.",
    },
    {
        id: "ideogram_v_3_quality",
        name: "Ideogram 3.0 Quality",
        provider: "ideogram",
        group: "ideogram",
        icon: IdeogramIcon,
        price: 0.08,
        is_ai: true,
        description: "Haute qualité d’image avec un bon sens de la mise en page visuelle.",
    },

    // flux
    {
        id: "flux_1_dev",
        name: "Flux.1 [dev]",
        provider: "flux",
        group: "flux",
        icon: FluxIcon,
        price: 0.025,
        is_ai: true,
        description: "Modèle flexible pour des tests ou des styles visuels expérimentaux.",
    },
    {
        id: "flux_1_pro",
        name: "Flux.1 [pro]",
        provider: "flux",
        group: "flux",
        icon: FluxIcon,
        price: 0.05,
        is_ai: true,
        description: "Permet la création d’illustrations soignées et visuellement équilibrées.",
    },
    {
        id: "flux_1_1_pro",
        name: "Flux.1.1 [pro]",
        provider: "flux",
        group: "flux",
        icon: FluxIcon,
        price: 0.04,
        is_ai: true,
        description: "Génère des images nettes avec un bon sens du cadrage et du détail.",
    },
    {
        id: "flux_1_1_pro_ultra",
        name: "Flux.1.1 [pro] Ultra",
        provider: "flux",
        group: "flux",
        icon: FluxIcon,
        price: 0.06,
        is_ai: true,
        description: "Offre des visuels de très haute définition avec un rendu photoréaliste.",
    },
    {
        id: "flux_kontext_pro",
        name: "Flux.1 Kontext [pro]",
        provider: "flux",
        group: "flux",
        icon: FluxIcon,
        price: 0.04,
        is_ai: true,
        description: "Permet la création d’illustrations soignées et visuellement équilibrées.",
    },
    {
        id: "flux_kontext_max",
        name: "Flux.1 Kontext [max]",
        provider: "flux",
        group: "flux",
        icon: FluxIcon,
        price: 0.08,
        is_ai: true,
        description: "Offre des visuels de très haute définition avec un rendu photoréaliste.",
    },

    // grok
    {
        id: "grok_2_image",
        name: "Grok 2 Image",
        provider: "grok",
        group: "grok",
        icon: GrokIcon,
        price: 0.07,
        is_ai: true,
        description: "Approche créative pour générer des images expressives et originales.",
    },

    // google
    {
        id: "gemini_2_5_flash_image",
        name: "Gemini 2.5 Flash",
        provider: "google",
        group: "google",
        icon: GeminiIcon,
        price: 0.039,
        is_ai: true,
        description: "Offre des visuels de très haute définition avec un rendu photoréaliste.",
    },

    // stock
    {
        id: "unsplash",
        icon: UnsplashIcon,
        name: "Unsplash",
        provider: "free_stock",
        group: "free_stock",
        description: "Banque d’images libres de haute qualité pour un usage immédiat.",
    },
    {
        id: "pexels",
        icon: PexelsIcon,
        name: "Pexels",
        provider: "free_stock",
        group: "free_stock",
        description: "Photos libres de droits, variées et bien catégorisées.",
    },
    {
        id: "pixabay",
        icon: PixabayIcon,
        name: "Pixabay",
        provider: "free_stock",
        group: "free_stock",
        description: "Grande bibliothèque d’images et d’illustrations gratuites.",
    },

    // scraping
    {
        id: "google_image",
        icon: GoogleIcon,
        name: "Google Image",
        provider: "scraping",
        group: "scraping",
        description: "Recherche d’images automatisée à partir de Google.",
    },
    {
        id: "bing_image",
        icon: BingIcon,
        name: "Bing Image",
        provider: "scraping",
        group: "scraping",
        description: "Accès rapide à des images issues des résultats Bing.",
    },
];

export const getModel = (model) => {
    return _find(models, ["id", model]);
};

export const providers = [
    {
        id: "dall_e",
        name: "OpenAI",
    },
    {
        id: "stable_diffusion",
        name: "Stable Diffusion",
    },
    {
        id: "ideogram",
        name: "Ideogram",
    },
    {
        id: "flux",
        name: "Flux",
    },
    {
        id: "google",
        name: "Google",
    },
    {
        id: "grok",
        name: "Grok (xAI)",
    },
    {
        id: "free_stock",
        name: "Banque d'images libre de droits",
    },
    {
        id: "scraping",
        name: "Scraping",
    },
];

export const getProvider = (provider) => {
    return _find(providers, ["id", provider]);
};

export const modelsByProvider = _map(_groupBy(models, "provider"), (items, provider) => {
    return {
        name: getProvider(provider).name,
        items: items,
    };
});

export const aiModelsByProvider = _map(_groupBy(_filter(models, "is_ai"), "provider"), (items, provider) => {
    return {
        name: getProvider(provider).name,
        items: items,
    };
});

export const groups = [
    {
        id: "recommended",
        name: "Recommandés",
    },
    {
        id: "dall_e",
        name: "OpenAI",
    },
    {
        id: "stable_diffusion",
        name: "Stable Diffusion",
    },
    {
        id: "ideogram",
        name: "Ideogram",
    },
    {
        id: "flux",
        name: "Flux",
    },
    {
        id: "google",
        name: "Google",
    },
    {
        id: "grok",
        name: "Grok (xAI)",
    },
    {
        id: "free_stock",
        name: "Banque d'images libre de droits",
    },
    {
        id: "scraping",
        name: "Scraping",
    },
];

export const getGroup = (group) => {
    return _find(groups, ["id", group]);
};
